module.exports = __webpack_public_path__ + "media/honey-icons/slt_3_3b_slt5-28fb7257.svg";